/**
 * Recursively removes Apollo's `__typename` fields from a queried value so it
 * can be round-tripped back into a mutation input (which rejects `__typename`).
 */
export const stripTypenames = <T>(value: T): T => {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) {
    return value.map(stripTypenames) as unknown as T;
  }
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (k === '__typename') continue;
      out[k] = stripTypenames(v);
    }
    return out as T;
  }
  return value;
};
